import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SliderBox } from '../../../molecules/slider-box';

export const SettingsPvStringNumber = () => {
  return (
    <SliderBox
      title={
        <FormattedMessage
          id="settings.PV.StringNumber"
          defaultMessage="Počet stringů střídače"
        />
      }
      subtitle={
        <FormattedMessage
          id="settings.PV.StringNumber.subtitle"
          defaultMessage="Počet stringů střídače zobrazovaný v aplikaci na záložce FVE"
        />
      }
      variableId="PV_STRING_NUMBER"
      visibility={{ variableId: 'PV_ACTUAL_POWER_STRING_V' }}
      opts={{
        maximumFractionDigits: 0,
      }}
      min={1}
      max={6}
    />
  );
};
